// import { Breadcrumb, ConfigProvider, Input, Pagination, PaginationProps, Select, Table, TableColumnsType } from "antd"
import { Breadcrumb, ConfigProvider, Input, Pagination, PaginationProps, Select } from "antd";
import { AgGridReact } from "ag-grid-react";
import Layout from "../../../Layout"
import { CaretDownOutlined, CaretUpOutlined, DeleteOutlined, DownloadOutlined, EditOutlined, PlusOutlined, SearchOutlined, UploadOutlined } from "@ant-design/icons"
import viVN from 'antd/locale/vi_VN';
import { useCallback, useEffect, useRef, useState } from "react";
import { TableProps } from "antd/lib";
import { ModalCreateColorCar } from "./Modal/ModalCreateColorCar";
import { ModalEditColorCar } from "./Modal/ModalEditColorCar";
import ModalDeleteManager from "../../../components/ModalDeleteManager";
import useToast from "../../../hook/useToast";
import useDebounce from "../../../hook/useDebounce";
import { getListCarColor } from "../../../api/colorCar/colorCarApi";
import * as colorCarApi from "../../../api/colorCar/colorCarApi"
import { checkDisabledPermission, dataPagination, exportExcel, findChildIdByUrl, fommatSelectOption, getUserPermissions } from "../../../until";
import { getListCarCompany, ICarCompany, IRelative } from "../../../api/selectOptions/selectOptionsApi";
import useThrottle from "../../../hook/useThrottle";
import { API_URL, LIMIT_EXPORT_EXCEL, NO_DATA } from "../../../env";
import { selectorMenu } from "../../../store/slices/menuSlice";
import { useSelector } from "react-redux";
import ModalManagerGroupColor from "./Modal/ModalManagerGroupColor";
import ImportDataColorCar from "../../Customers/Component/ImportDataModal/ImportDataColorcar";
import useLoading from "../../../hook/useLoading";
import { ResponseSuccessDataError, uploadFileColorCar } from "../../../api/customer/customerApi";
import { formatNumber } from "../../../services/mixin";
import { useLocation } from "react-router-dom";
import { selectorPermission } from "../../../store/slices/permissionSlice";
import { NodataTable } from "../../../components/NoDataTable";
import './styles.scss'
import { ColDef, GridApi, ICellRendererParams, IHeaderParams, SelectionChangedEvent } from "ag-grid-community";

interface DataType {
  key: React.Key
  colorId: number
  stt: number
  ddms: string
  nameColorCar: string
  nameBrand: string
  codeColor: string
  groupColorCar: string
}

export const CarColorManagement: React.FC = () => {
  useEffect(() => {
    gCLCarCompany()
    gListCarColorGroup()
  }, [])

  const pushToast = useToast()
  const pushLoading = useLoading()
  const location = useLocation();
  const permissionSlice = useSelector(selectorPermission)
  const { add, edit, delete: isdelete, download, upload } = getUserPermissions(permissionSlice, location.pathname)

  const gridApiRef = useRef<GridApi | null>(null);


  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [IsOpenCreateColorCar, setIsOpenCreateColorCar] = useState<boolean>(false)
  const [IsOpenEditColorCar, setIsOpenEditColorCar] = useState<boolean>(false)
  const [IsOpenDeleteColorCar, setIsOpenDeleteColorCar] = useState<boolean>(false)
  const [search, setSearch] = useState<string>()
  const [idColorCar, setIdColorCar] = useState<number>()
  const [type, setType] = useState<string>("")
  const [isOpenGroupColor, setIsOpenGroupColor] = useState(false)
  const [showImportDataModal, setShowImportDataModal] = useState(false)

  const [fileData, setFileData] = useState({} as any)
  const [paginationTmp, setPaginationTmp] = useState<number>(1)
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });
  const [listCarColor, setListCarColor] = useState<DataType[]>([])
  const [inForCarColor, setinForCarColor] = useState<colorCarApi.ICarColorEdit>()
  const [sLCategoryCar, setSLCategoryCar] = useState<ICarCompany[]>([])
  const [listGroupColor, setListGroupColor] = useState<IRelative[]>([])



  const [defaulFilter, setDefaultFilter] = useState<colorCarApi.IColorFilter>()


  const safeString = (value: unknown) => String(value ?? "");

  const sortByStringLength = (field: keyof DataType) => {
    return (a: DataType, b: DataType) =>
      safeString(a[field]).length - safeString(b[field]).length;
  };

  const sortByNumber = (field: keyof DataType) => {
    return (a: DataType, b: DataType) =>
      Number(a[field] ?? 0) - Number(b[field] ?? 0);
  };



  const CustomSortableHeader = (props: IHeaderParams) => {
    const [activeSort, setActiveSort] = useState<null | 'asc' | 'desc'>(null);


    const handleSortRequest = (order: 'asc' | 'desc' | null) => {
      let newSort: null | 'asc' | 'desc' = null;
      switch (order) {
        case 'asc':
          newSort = 'desc'
          break;
        case 'desc':
          newSort = null
          break;
        default:
          newSort = 'asc'
          break;
      }
      setActiveSort(newSort);
      props.api.applyColumnState({
        state: [
          {
            colId: props.column.getId(),
            sort: newSort || undefined,
          }
        ],
        defaultState: { sort: null },
      });
    };
    return (
      <div className='d-flex align-center gap-1'>
        <span>{props.displayName}</span>
        <div className='d-flex align-center gap-1'>
          <div className='d-flex flex-column'
            onClick={() => handleSortRequest(activeSort)}
          >
            <CaretUpOutlined
              hidden={activeSort === 'desc'}
              className={`cursor-pointer text-10-px `}
            />
            <CaretDownOutlined
              hidden={activeSort === 'asc'}
              className={`cursor-pointer text-10-px `}
            />
          </div>

        </div>

      </div>
    );
  };

  const columnDefs: ColDef<DataType>[] = [
    {
      headerName: "Hành động",
      field: "colorId",
      width: 160,
      sortable: false,
      filter: false,
      headerComponentParams: {
        template: '<span class="w-full flex items-center justify-center">Hành động</span>'
      },
      cellRenderer: (params: ICellRendererParams<DataType>) => {
        const record = params.data;

        if (!record) return null;

        return (
          <div className="custom-page-css flex gap-2 items-center justify-center">
            <div
              className={`item-hd-table cursor-pointer ${checkDisabledPermission(edit)}`}
              onClick={() => ginforColorCar(Number(record.colorId))}
            >
              <span>
                <EditOutlined />
              </span>
            </div>

            <DeleteOutlined
              className={`text-F5222D text-sm border-EAECF0 p-5-px bg-white rounded-2 ${checkDisabledPermission(isdelete)}`}
              onClick={() => openModalDeleteColorCar(Number(record.colorId))}
            />
          </div>
        );
      },
    },
    {
      headerName: "STT",
      field: "stt",
      minWidth: 60,
      cellClass: "text-center",
      resizable: true,
      headerComponentParams: {
        template: '<span class="w-full flex items-center justify-center">STT</span>'
      },
      comparator: (_valueA, _valueB, nodeA, nodeB) => {
        return sortByNumber("stt")(nodeA.data!, nodeB.data!);
      },
    },
    {
      headerName: "Mã màu DDMS",
      field: "ddms",
      resizable: true,
      minWidth: 220,
      cellRenderer: (params: ICellRendererParams<DataType>) => (
        <div className="text-2-row">{params.value || NO_DATA}</div>
      ),
      headerComponent: CustomSortableHeader,
    },
    {
      headerName: "Tên màu xe",
      field: "nameColorCar",
      resizable: true,
      minWidth: 220,
      cellRenderer: (params: ICellRendererParams<DataType>) => (
        <div className="text-2-row">{params.value || NO_DATA}</div>
      ),
      headerComponent: CustomSortableHeader,

    },
    {
      headerName: "Tên thương hiệu",
      field: "nameBrand",
      minWidth: 171,
      cellRenderer: (params: ICellRendererParams<DataType>) => (
        <div className="text-2-row">{params.value || NO_DATA}</div>
      ),
      headerComponent: CustomSortableHeader,

    },
    {
      headerName: "Mã màu đồ họa",
      field: "codeColor",
      resizable: true,
      minWidth: 112,
      cellRenderer: (params: ICellRendererParams<DataType>) => (
        <div className="text-2-row">{params.value || NO_DATA}</div>
      ),
      headerComponent: CustomSortableHeader,
    },
    {
      headerName: "Nhóm màu xe",
      field: "groupColorCar",
      resizable: true,
      minWidth: 220,
      cellRenderer: (params: ICellRendererParams<DataType>) => (
        <div className="text-2-row">{params.value || NO_DATA}</div>
      ),
      headerComponent: CustomSortableHeader,

    },
  ];


  const getRowId = (params: { data: DataType }) => String(params.data.key);

  const onSelectionChanged = (event: SelectionChangedEvent<DataType>) => {
    const selectedRows = event.api.getSelectedRows();
    setSelectedRowKeys(selectedRows.map((item) => item.key));
  };

  const gListCarColorGroup = async () => {
    const result = await colorCarApi.getListCarColorGroup();

    if (result?.status) {
      setListGroupColor(result.data)
    } else {
      pushToast(result?.message, "warning")
    }
  }
  const gCLCarCompany = async () => {
    const result = await getListCarCompany()
    if (result?.status) {
      setSLCategoryCar(result.data)
    } else {
      pushToast(result?.message, "warning")
    }
  }

  const gListCarColor = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
    pushLoading(true)
    const result = await getListCarColor(pageSize, pageCurent, defaulFilter?.search, defaulFilter?.categoryCarId, defaulFilter?.groupColorId)
    if (result?.status) {
      setListCarColor(convertData(result.data, pageCurent, pageSize))
      setPagination({ current: pageCurent, total: result.total, pageSize })
      setPaginationTmp(pageCurent)
    }
    pushLoading(false)
  }, 1000)

  const convertData = (data: colorCarApi.ICarColor[], pageCurent: number, pageSize: number) => {
    var stt = (pageCurent - 1) * pageSize + 1;
    const convertData = data.map((item) => ({
      key: item?.id,
      colorId: item?.colorId,
      stt: stt++,
      ddms: item?.titleDDMS,
      nameColorCar: item?.title,
      nameBrand: item?.categoryCarTitle,
      groupColorCar: item?.groupColorTitle,
      codeColor: item?.code
    }))

    return convertData

  }
  const ginforColorCar = async (id: number) => {
    const result = await colorCarApi.gInforColorCar(id)
    if (result?.status) {
      setIsOpenEditColorCar(true)
      setinForCarColor(result?.data)
    } else {
      pushToast(result?.message, "warning")
    }
  }

  const onSubmitFormModalAdd = (isSuccess: boolean, message?: string) => {
    if (isSuccess) {
      pushToast(message, "success")
      setIsOpenCreateColorCar(false)
      gListCarColor(pagination.current, pagination.pageSize)
    } else {
      pushToast(message, "warning")
    }
  }
  const onSubmitFormModalEdit = (isSuccess: boolean, message?: string) => {
    if (isSuccess) {
      pushToast(message, "success")
      setIsOpenEditColorCar(false)
      gListCarColor(pagination.current, pagination.pageSize)
    } else {
      pushToast(message, "warning")
    }
  }
  const openModalDeleteColorCar = (id: number) => {
    setIdColorCar(id)
    setIsOpenDeleteColorCar(true)
  }

  const closeModalDeleteColorCar = () => {
    setIdColorCar(undefined)
    setIsOpenDeleteColorCar(false)
  }

  const onConfirmDelete = async () => {
    const result = await colorCarApi.deleteCarColor(Number(idColorCar))
    if (result?.status) {
      pushToast(result.message, "success")
      closeModalDeleteColorCar()
      gListCarColor(pagination.current, pagination.pageSize)
    } else {
      pushToast(result?.message, "warning")
    }
  }

  const glistByExcel = useThrottle(async () => {
    const result = await getListCarColor(LIMIT_EXPORT_EXCEL, 1, search)
    if (result?.status) {
      formattedDataExcel(result.data, result?.message)
    } else {
      pushToast(result?.message, "warning")
    }
  }, 1000)

  const formattedDataExcel = (data: colorCarApi.ICarColor[], message?: string) => {

    const formattedData = data.map((item) => {
      return {
        "Mã màu DDMS": item.titleDDMS,
        "Tên màu xe": item.title,
        "Tên thương hiệu": item.categoryCarTitle,
        "Mã màu đồ họa": item.code,
        "Nhóm màu xe": item.groupColorTitle
      }
    }
    );
    exportExcel(formattedData, message)
  }

  const glistSelectedExel = () => {
    const selectedData = listCarColor.filter((item) => selectedRowKeys.includes(item.key))
    formattedDataSelectedExcel(selectedData)
  }
  const formattedDataSelectedExcel = (data: DataType[],) => {
    const formattedDataSelected = data.map((item) => {
      return {
        "Mã màu DDMS": item.ddms,
        "Tên màu xe": item.nameColorCar,
        "Tên thương hiệu": item.nameBrand,
        "Mã màu đồ họa": item.codeColor,
        "Nhóm màu xe": item.groupColorCar
      }
    }
    );
    exportExcel(formattedDataSelected, "Danh sách màu xe được chọn")
  }

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const onChangeTB: TableProps<DataType>['onChange'] = (pagination, filters, sorter, extra) => {
  };
  const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    setPaginationTmp(pageNumber);
    setPagination((prev) => ({ ...prev, current: pageNumber, pageSize }))
    gListCarColor(pageNumber, pageSize)
  }
  const handleFile = (file: any) => {
    setFileData(file)
  }

  const handleUpload = async (type: string): Promise<ResponseSuccessDataError> => {
    setType(type)
    pushLoading(true)

    const result = await uploadFileColorCar(fileData)
    if (result?.status) {
      pushToast(result?.message, "success")

    }
    pushLoading(false)
    return result
  }

  useEffect(() => {
    gListCarColor()
    gListCarColorGroup
  }, [defaulFilter])
  return (
    <Layout>
      <ModalCreateColorCar
        isOpen={IsOpenCreateColorCar}
        sLCategoryCar={sLCategoryCar}
        listGroupColor={listGroupColor}
        onClose={() => setIsOpenCreateColorCar(false)}
        onSubmitFormModalAdd={onSubmitFormModalAdd}
      />
      <ModalEditColorCar
        isOpen={IsOpenEditColorCar}
        inForCarColor={inForCarColor}
        sLCategoryCar={sLCategoryCar}
        listGroupColor={listGroupColor}
        onSubmitFormModalEdit={onSubmitFormModalEdit}
        onClose={() => setIsOpenEditColorCar(false)}
      />
      <ModalDeleteManager
        isOpen={IsOpenDeleteColorCar}
        onConfirm={onConfirmDelete}
        closeModal={closeModalDeleteColorCar}
        title='Bạn có chắc chắn xóa màu xe này'
        titleDelete='Xóa màu xe'
        content='Màu xe và dữ liệu liên quan sẽ bị xóa vĩnh viễn không thể khôi phục'
      />
      <ModalManagerGroupColor
        isOpen={isOpenGroupColor}
        listGroupColor={listGroupColor}
        gListCarColorGroup={gListCarColorGroup}
        closeModal={() => setIsOpenGroupColor(false)}
      />
      <ImportDataColorCar
        show={showImportDataModal}
        fileData={fileData}
        linkExamplPre={`${API_URL}uploads/fileExcel/carColor/DanhMucMauDDMS.xlsx`}
        type={"dataColorCarError"}

        setFileData={setFileData}
        handleUpload={() => handleUpload(type)}
        handleFile={handleFile}
        gListCarColor={gListCarColor}
        modalClose={() => setShowImportDataModal(false)}
      />
      <Breadcrumb
        items={[
          {
            title: 'THACO AUTO CRM',
          },
          {
            title: <a href="/">Quản lý danh mục xe</a>,
          },
          {
            title: 'Quản lý màu xe',
          },
        ]}
      />
      <div className='title-page'>
        Quản lý màu xe
      </div>
      <div className='d-flex gap-3 pb-18-px vehicle-category-management-filter'>
        <div className="w-215-px border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center   h-8 justify-between overflow-hidden">
          <Input
            placeholder="Tìm kiếm theo màu xe"
            className="custom-input-css custom-page-css border-none outline-none bg-transparent h-full focus-none"
            value={defaulFilter?.search}
            onChange={(e) => setDefaultFilter({ ...defaulFilter, search: e.target.value })}
          />
          <div className=" border-l-F2F4F7 h-full d-flex align-center">
            <SearchOutlined className="text-sm text-98A2B3 px-9-px" />
          </div>
        </div>
        <div className='w-215-px'>
          <Select
            allowClear
            placeholder="Nhóm màu xe"
            options={fommatSelectOption(listGroupColor)}
            value={defaulFilter?.groupColorId}
            onChange={(e) => setDefaultFilter({ ...defaulFilter, groupColorId: e })}
            className="custome-select rs-select"

            popupMatchSelectWidth={false}

          />
        </div>
        <div className='w-215-px'>
          <Select
            allowClear
            placeholder="Thương hiệu"
            options={fommatSelectOption(sLCategoryCar)}
            value={defaulFilter?.categoryCarId}
            onChange={(e) => setDefaultFilter({ ...defaulFilter, categoryCarId: e })}
            className="custome-select rs-select"

            popupMatchSelectWidth={false}

          />
        </div>
        <button className='border-EAECF0 bg-white rounded-6-px w-149-px py-2 h-8 d-flex justify-center align-center gap-10-px shadow-btn-save'
          onClick={() => setIsOpenGroupColor(!isOpenGroupColor)}
        >
          <span className='text-sm fw-400 font-regular text-344054 white-space-nowrap'>Quản lý nhóm màu</span>
        </button>
        <button
          className={`border-EAECF0 bg-white rounded-6-px w-106-px py-2 h-8 d-flex justify-center align-center gap-10-px shadow-btn-save ${checkDisabledPermission(download)}`}
          onClick={selectedRowKeys.length ? glistSelectedExel : glistByExcel}
        >
          <DownloadOutlined className='text-sm text-344054' />
          <span className='text-sm fw-400 font-regular text-344054 white-space-nowrap'>Xuất DS</span>
        </button>
        <button
          className={`border-EAECF0 bg-white rounded-6-px w-111-px py-2 h-8 d-flex justify-center align-center gap-10-px shadow-btn-save ${checkDisabledPermission(upload)}`}
          onClick={() => setShowImportDataModal(true)}
        >
          <UploadOutlined className='text-sm text-344054' />
          <span className='text-sm fw-400 font-regular text-344054 white-space-nowrap'>Nhập DS</span>
        </button>
        <button className={`border-none bg-096DD9 rounded-6-px  py-2 h-8 d-flex justify-center align-center gap-10-px w-107-px ${checkDisabledPermission(add)}`}
          onClick={() => setIsOpenCreateColorCar(true)}
        >
          <PlusOutlined className='text-sm text-white' />
          <span className='text-sm fw-400 font-regular text-white white-space-nowrap'>Tạo mới</span>
        </button>
      </div>

      <div className={` custom-page-css flex flex-1 flex-col justify-between`}>
        {/* <div className="ag-theme-alpine custom-table-ag custom-css-table" style={{ width: '100%', height: 610 }}>
          <AgGridReact
            className="my-auto-height-grid"
            getRowStyle={(params: any) => ({
              backgroundColor: params?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
            })}
            rowData={listCarColor}
            columnDefs={columnDefs}
            rowHeight={55}
            rowSelection={{ mode: 'multiRow' }}
            overlayNoRowsTemplate={NodataTable}

            onSelectionChanged={onSelectionChanged}
            // Performance optimizations
            suppressColumnVirtualisation={true} // Giữ tất cả columns trong DOM
            suppressRowVirtualisation={false} // Giữ row virtualization
            enableCellTextSelection={true}
            ensureDomOrder={true}
            debounceVerticalScrollbar={true}
            suppressScrollOnNewData={true}
            suppressDragLeaveHidesColumns={true}

          />
        </div> */}
        <div className="ag-theme-alpine custom-table-ag custom-css-table "
          style={{ width: '100%', height: 650 }}

        >
          <AgGridReact
            // domLayout="autoHeight"
            className="my-auto-height-grid"
            getRowStyle={(params: any) => ({
              backgroundColor: params?.node?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
            })}
            columnDefs={columnDefs}
            rowData={listCarColor}
            rowHeight={55}
            defaultColDef={{
              resizable: true
            }}
            overlayNoRowsTemplate={NodataTable}
            rowSelection={{ mode: 'multiRow' }}
            getRowId={getRowId}
            // onGridReady={onGridReady}
            onSelectionChanged={onSelectionChanged}
          />
        </div>
        <ConfigProvider locale={viVN}>
          <div className="pagination-block">
            <Pagination
              showSizeChanger
              current={paginationTmp}
              pageSize={pagination.pageSize}
              total={pagination.total}
              itemRender={(page, type, originalElement) => {
                // Chỉ custom khi là nút số trang
                if (type === 'page') {
                  return <span>{formatNumber(page)}</span>;
                }
                // prev / next / jump-prev / jump-next giữ nguyên
                return originalElement;
              }}
              showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize, paginationTmp).totalPage} trang`}
              className='rs-pagination'
              onChange={onPaginationChange}

            />
          </div>
        </ConfigProvider>
      </div>
    </Layout>
  )
}
